// extracted by mini-css-extract-plugin
export default {"searchResults":"SearchContents_searchResults__Hq47c","resultCount":"SearchContents_resultCount__xvKDE"};